<template>
  <div class="futureCurrentInfo">
    <!-- “futureCurrentInfo”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></sirui-search>
    <div class="main-content">
      <vxe-grid
        border
        resizable
        align="left"
        size="mini"
        show-overflow
        ref="table"
        :auto-resize="true"
        :data="tableData"
        @cell-click="rowClick"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title"
          :edit-render="item.editRender"
        >
        </vxe-table-column>
      </vxe-grid>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-count="page.pages"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>

      <!-- tab页 -->
      <el-tabs class="batchTabs" type="border-card">
        <!-- 现货信息 -->
        <el-tab-pane :label="$t('futuresStrategy.collapseTitle.currentTitle')">
          <current-info ref="currentInfo" />
        </el-tab-pane>
        <!-- 期货信息 -->
        <el-tab-pane :label="$t('futuresStrategy.collapseTitle.futuresTitle')">
          <futures-info ref="futuresInfo" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
  // import API from '@/api/futuresStrategy/index';
  import { mapState } from 'vuex';
  import SiruiSearch from '@/components/SiruiSearch';
  import tableMixins from '@/common/mixins/table.js';
  import CurrentInfo from './components/currentInfo'; // 现货信息
  import FuturesInfo from './components/futuresInfo'; // 期货信息
  export default {
    name: 'basisList',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      CurrentInfo,
      FuturesInfo,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          //   策略编号
          {
            name: this.$t('futuresStrategy.futuresStrategyList.search.ptcombiNo'),
            prop: 'ptcombiNo',
            type: 'input',
            clearable: true,
          },
          //   业务部门
          {
            prop: 'departmentCode',
            name: this.$t('futuresStrategy.futuresStrategyList.search.departmentName'),
            type: 'select',
            placeholder: this.$t('futuresStrategy.futuresStrategyList.placeholder.departmentCode'),
            options: this.slipDepartmentList,
            clearable: true,
          },
          //策略名称
          {
            name: this.$t('futuresStrategy.futuresStrategyList.search.combiName'),
            prop: 'combiName',
            type: 'input',
            clearable: true,
          },
          //项目名称
          {
            name: this.$t('futuresStrategy.futuresStrategyList.search.projectName'),
            prop: 'projectName',
            type: 'input',
            clearable: true,
          },
        ];
      },
      columnListDefault() {
        return [
          //序号
          //{ type: "checkbox", visible: true, width: "50", fixed: "left" },
          { type: 'seq', visible: true, width: '50', fixed: 'left', title: this.$t('table.index') },
          //交易日期
          {
            field: 'initDate',
            title: this.$t('futuresStrategy.futuresStrategyList.table.initDate'),
            visible: true,
            width: 80,
          },
          //业务部门
          {
            field: 'departmentName',
            title: this.$t('futuresStrategy.futuresStrategyList.table.departmentName'),
            visible: true,
            width: 120,
          },
          //期货买量(吨)
          {
            field: 'buyQuantity',
            title: this.$t('futuresStrategy.futuresStrategyList.table.buyQuantity'),
            visible: true,
          },
          //期货卖量(吨)
          {
            field: 'sellQuantity',
            title: this.$t('futuresStrategy.futuresStrategyList.table.sellQuantity'),
            visible: true,
          },
          //期货净持仓(吨)
          {
            field: 'holdQuantity',
            title: this.$t('futuresStrategy.futuresStrategyList.table.holdQuantity'),
            visible: true,
          },
          //期货浮动盈亏(万元)
          {
            field: 'holdIncomeFloat',
            title: this.$t('futuresStrategy.futuresStrategyList.table.holdIncomeFloat'),
            visible: true,
          },
          //当月平仓盈亏(万元)
          {
            field: 'monthDropIncome',
            title: this.$t('futuresStrategy.futuresStrategyList.table.monthDropIncome'),
            visible: true,
            width: 150,
          },
          //现货数量(吨)
          {
            field: 'goodsQuantity',
            title: this.$t('futuresStrategy.futuresStrategyList.table.goodsQuantity'),
            visible: true,
          },
          //现货潜盈亏(万元)
          {
            field: 'goodsProtentialIncome',
            title: this.$t('futuresStrategy.futuresStrategyList.table.goodsProtentialIncome'),
            visible: true,
          },
          //现货实现盈亏(万元)
          {
            field: 'goodsActualIncome',
            title: this.$t('futuresStrategy.futuresStrategyList.table.goodsActualIncome'),
            visible: true,
            width: 150,
          },
          //潜盈亏合计(万元)
          {
            field: 'protentialIncome',
            title: this.$t('futuresStrategy.futuresStrategyList.table.protentialIncome'),
            visible: true,
          },
          //盈亏合计(万元)
          {
            field: 'incomeSum',
            title: this.$t('futuresStrategy.futuresStrategyList.table.incomeSum'),
            visible: true,
          },
          //敞口数量(吨)
          {
            field: 'exposureAmount',
            title: this.$t('futuresStrategy.futuresStrategyList.table.exposureAmount'),
            visible: true,
          },
        ];
      },
    },
    data() {
      return {
        loading: false,
        query: {
          ptcombiNo: null, //策略编号
          departmentCode: null, //业务部门
          combiName: null, //策略名称
          projectName: null, //项目名称
        },
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        }, //
        tableData: [], //列表数据
      };
    },
    mounted() {
      //this.getData();
      this.getButtonList();
    },
    methods: {
      //获取table数据
      getData() {
        /* const params = JSON.parse(JSON.stringify(this.searchForm));
      params.pageSize = this.page.pageSize;
      params.pageNum = this.page.pageNum;
      this.load = true;
      this.$axios.post(API.SELECT_PLAN_BUSINESS_BYPAGE, params).then(res => {
        this.load = false;
        if (res.data.code === 0) {
          this.tableData = res.data.data.records;
          this.tableData.forEach(item => {
            item.companyDepartment = [
              item.planCompanyCode,
              item.planDepartmentCode
            ];
          });
          this.page.total = res.data.data.total;
        }
      }); */
      },

      //点击表格记录正在编辑哪一行
      rowClick(row) {
        this.$message({ showClose: true, type: 'info', message: row });
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
    },
  };
</script>
